'use client';

import { useState, useEffect } from 'react';
import GalacticPortfolio from '@/components/GalacticPortfolio';
import LoadingScreen from '@/components/LoadingScreen';

export default function Home() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simular carregamento por 2 segundos
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <main className="w-full h-screen overflow-hidden bg-black">
      <GalacticPortfolio />
    </main>
  );
}